import React from 'react'
import styles from './UsageSummary.module.css'

const UsageSummary = ({
  autoPay = false,
  card = '',
  onAutoPay,
  // `autoPayReady` distinguishes "still loading" from "loaded and OFF". Until the
  // payment-method data has actually arrived we must NOT paint a value, because
  // showing "OFF" while loading is wrong data. When false → the badge/card render
  // blank; when true → the real ON/OFF + card show.
  autoPayReady = false,
  // The info rows above Auto Pay. Always supplied by the parent from REAL data;
  // no static fallback — empty until the data arrives.
  rows: rowsProp,
}) => {
  const rows = rowsProp || []

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Usage Summary</h3>
      {rows.map((r) => (
        <div key={r.label} className={styles.row}>
          <span className={styles.label}>{r.label}</span>
          <span className={styles.value}>{r.value}</span>
        </div>
      ))}

      <button type="button" className={styles.autoPayRow} onClick={onAutoPay}>
        <span className={styles.label}>Auto Pay</span>
        <span className={styles.autoPayRight}>
          {/* Until the data is ready, show nothing (never a wrong "OFF"). */}
          {autoPayReady && (
            <>
              <span className={`${styles.badge} ${autoPay ? styles.on : styles.off}`}>
                {autoPay ? 'ON' : 'OFF'}
              </span>
              {card && <span className={styles.cardNo}>({card})</span>}
            </>
          )}
          <span className={styles.chevron}>›</span>
        </span>
      </button>
    </div>
  )
}

export default UsageSummary
